import styled from '@emotion/styled';
import { border } from 'styled-system';
import { Palette } from '../../constants/palette';
import { Box } from '../box';
export const CardBorderVariants = {
    dark: '#01314A',
    light: '#E5E5E5',
};
export var CardPalette;
(function (CardPalette) {
    CardPalette["gray90"] = "#E5E5E5";
    CardPalette["gray96"] = "#F5F5F5";
    CardPalette["white"] = "#FFFFFF";
    CardPalette["blue"] = "#62A0F8";
    CardPalette["updaterRed"] = "#F94550";
})(CardPalette || (CardPalette = {}));
export const defaultCardBorder = (props) => `1px solid ${CardBorderVariants[props.borderColor || 'light']}`;
export const Card = styled(Box) `
  border-radius: ${(props) => props.variant === 'rounded' ? props.theme.radii.m : props.theme.radii.xs};
  border: ${defaultCardBorder};
  background-color: ${(props) => props.backgroundColor};
  padding: 12px 16px;
  display: inline-block;
  ${border}
`;
Card.defaultProps = {
    variant: 'squared',
    backgroundColor: CardPalette.white,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FyZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL2NhcmQvQ2FyZC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0saUJBQWlCLENBQUM7QUFFckMsT0FBTyxFQUFFLE1BQU0sRUFBZSxNQUFNLGVBQWUsQ0FBQztBQUNwRCxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0seUJBQXlCLENBQUM7QUFDbEQsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLFFBQVEsQ0FBQztBQUU3QixNQUFNLENBQUMsTUFBTSxrQkFBa0IsR0FBRztJQUNoQyxJQUFJLEVBQUUsU0FBUztJQUNmLEtBQUssRUFBRSxTQUFTO0NBQ1IsQ0FBQztBQUVYLE1BQU0sQ0FBTixJQUFZLFdBTVg7QUFORCxXQUFZLFdBQVc7SUFDckIsaUNBQXVCLENBQUE7SUFDdkIsaUNBQXVCLENBQUE7SUFDdkIsZ0NBQXFCLENBQUE7SUFDckIsK0JBQW1CLENBQUE7SUFDbkIscUNBQStCLENBQUE7QUFDakMsQ0FBQyxFQU5XLFdBQVcsS0FBWCxXQUFXLFFBTXRCO0FBV0QsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsQ0FBQyxLQUFnQixFQUFFLEVBQUUsQ0FDcEQsYUFBYSxrQkFBa0IsQ0FBQyxLQUFLLENBQUMsV0FBVyxJQUFJLE9BQU8sQ0FBQyxFQUFFLENBQUM7QUFFbEUsTUFBTSxDQUFDLE1BQU0sSUFBSSxHQUFHLE1BQU0sQ0FBQyxHQUF1QixDQUFDLENBQVc7bUJBQzNDLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FDekIsS0FBSyxDQUFDLE9BQU8sS0FBSyxTQUFTLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsS0FBSyxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsRUFBRTtZQUNoRSxpQkFBaUI7c0JBQ1AsQ0FBQyxLQUFLLEVBQUUsRUFBRSxDQUFDLEtBQUssQ0FBQyxlQUFlOzs7SUFHbEQsTUFBTTtDQUNULENBQUM7QUFFRixJQUFJLENBQUMsWUFBWSxHQUFHO0lBQ2xCLE9BQU8sRUFBRSxTQUFTO0lBQ2xCLGVBQWUsRUFBRSxXQUFXLENBQUMsS0FBSztDQUNuQyxDQUFDIn0=